import { StyleProps } from "@shared/primitive-components"

export const unknownPropertyIcon = (props: StyleProps) => ({
  color: props.theme.palette.alert,
})
